import constants from './constants';
import getNav from './actions/getNav';
import load from '../../load';

const requestId = 'requestNav';

export { requestId };

export function requestNav(name) {
  return load(requestId, getNav, name);
}

export function showActions() {
  return {
    type: constants.actions.SHOW_ACTIONS,
  };
}

// for backwards compatibility do not use
export function receiveName(name) {
  return {
    type: constants.actions.RECEIVE_NAME,
    name,
  };
}

export function navItem(value) {
  return {
    type: constants.actions.NAV_ITEM,
    value,
  };
}

export default {
  requestNav,
  showActions,
  navItem,
};
